import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbPopoverModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../../core/i18n/i18n.module';
import { ActionButtonModule } from '../../../../../shared/components/action-button';
import { AreaOfUseAdminDeleteCategoryPopoverComponent } from './area-of-use-admin-delete-category-popover.component';

@NgModule({
  declarations: [AreaOfUseAdminDeleteCategoryPopoverComponent],
  imports: [CommonModule, I18nModule, NgbPopoverModule, ActionButtonModule, NgbTooltipModule, NzIconModule],
  exports: [AreaOfUseAdminDeleteCategoryPopoverComponent],
})
export class AreaOfUseAdminDeleteCategoryPopoverModule {}
